import { apiClient } from './client';
import type {
  ListaMovimientosResp,
  AccesosMetricas,
  PersonaDentro,
  TendenciaDia,
  TipoMovimiento,
  MetodoValidacion,
} from '@/types/dominio';

export interface ListaMovimientosParams {
  busqueda?: string;
  tipo?: TipoMovimiento;
  metodo?: MetodoValidacion;
  /** ISO 8601 — inicio del rango (inclusive). */
  desde?: string;
  /** ISO 8601 — fin del rango (inclusive). */
  hasta?: string;
  page?: number;
  pageSize?: number;
}

export async function getMovimientos(
  params: ListaMovimientosParams = {},
): Promise<ListaMovimientosResp> {
  const { data } = await apiClient.get<ListaMovimientosResp>('/accesos/movimientos', { params });
  return data;
}

export async function getMetricasAccesos(): Promise<AccesosMetricas> {
  const { data } = await apiClient.get<AccesosMetricas>('/accesos/metricas');
  return data;
}

export async function getDentro(): Promise<PersonaDentro[]> {
  const { data } = await apiClient.get<PersonaDentro[]>('/accesos/dentro');
  return data;
}

export async function getTendencia(dias = 7): Promise<TendenciaDia[]> {
  const { data } = await apiClient.get<TendenciaDia[]>('/accesos/tendencia', { params: { dias } });
  return data;
}
